export default __webpack_public_path__ + "static/media/bg.a40eeb9f.jpg";